import SelectAllIcon from "@mui/icons-material/SelectAll";
import PaletteLineIcon from "remixicon-react/PaletteLineIcon";
import TextIcon from "remixicon-react/TextIcon";
import LayoutMasonryLineIcon from "remixicon-react/LayoutMasonryLineIcon";

const sections = [
  {
    id: "texts",
    icon: <TextIcon />,
    label: "Textes",
  },
  {
    id: "colors",
    icon: <PaletteLineIcon />,
    label: "Couleurs",
  },
  {
    id: "selectors",
    icon: <SelectAllIcon />,
    label: "Sélecteurs",
  },
  {
    id: "components",
    icon: <LayoutMasonryLineIcon />,
    label: "Composants",
  },
];

export default sections;
